import { Component, OnInit } from '@angular/core';
import { NgForm, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { BackendService } from '../../shared/backend.service';
//import { NotificationService } from '../../notification/notification.service';
import { AuthService } from '../../shared/auth.service';
import CONFIG from '../../config';
import { OrderByService } from '../../shared/orderby.service';
import { PaginationService } from '../../shared/pagination.service';
import { Subscription } from 'rxjs/Subscription';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { DataEntryAccountEditComponent } from './dataentry-accountedit.component';
import { DataEntryDASubmissionComponent } from './dataentry-dasubmission.component';
import { AlertmessageService } from 'src/app/shared/alertmessage.service';
import { DatePipe } from '@angular/common';
import { Message } from '@angular/compiler/src/i18n/i18n_ast';
import { Router } from '@angular/router';
import { NotificationService } from 'src/app/notification.service';
//import { NotificationService } from 'src/app/notification.service';

@Component({
  selector: 'app-data-entry',
  templateUrl: './data-entry.component.html',
  styleUrls: ['./data-entry.component.scss'],
  providers: [OrderByService,AlertmessageService,DatePipe]
})
export class DataEntryComponent implements OnInit {


  bankId: any;
  branchcodes: any;
  bankbranchids: any;
  branchfiltercodes: any;
  bankcodevalue: any;
  branchcodevalue: any;
  submissionrecords: any;
  submissionrecordsfilter:any;
  submission: boolean = false;
  submisiionrecordtable: any;
  editvalue:boolean=true;
  hidebutton:boolean=true;
  accounttype: any;
  currency: any;
  currencies: any;
  afterEditData:any={};
  picker1: any;
  branchessss: Array<string>;
  dataEntry: FormGroup;
  dataEntryForm: FormGroup;
  newForm: FormGroup;
  tableForm: FormGroup;
  DateFilter: FormGroup;
  enddate: any;
  transdate: any;
  paymentdate: any;
  item: any;
  submittedYear: any;
  accValue:any;
  addValue:any;
  entryRangeSubscription: Subscription;
  entryRange: Array<number>;
  totalsubmissionrecordsEntries: any;
  displayvalue:any=null;
  items: any;
  active: string = '';
  ComponentName: any;
  editDate:any;
  editDate1:any;
  afterdate:any;
  dasubmission:any;
  spinner:boolean=true;
  years: number[] = [];

  constructor(
    public _formBuilder: FormBuilder,
    public backendService: BackendService,
    public authService: AuthService,
    public notificationService: NotificationService,
    public orderByService: OrderByService,
    public paginationService: PaginationService,
    public dialog: MatDialog,
    public alert:AlertmessageService,
    public  _datepipe:DatePipe,
    public router:Router
  ) {
    this.setForm();
  }

  ngOnInit() 
  {
    this.spinner=true;
    this.DateFilter = this._formBuilder.group({
      'enddate': [''],
      'paymentdate': ['']
    });
    this.submittedYear = new Date().getFullYear() - 1;
    this.transdate = new FormControl(new Date());
    this.enddate = new FormControl(new Date());
    this.paymentdate = new FormControl(new Date());
    
     this.getbankIdDropdown();
    this.editvalue=true;
    if(this.authService.LoginType!="Admin")
    {
      this.bankcodevalue=this.authService.TaskNumber;
      this.getAccountInfoGrid();
    }
    else
    {
      //this.getbankIdDropdown();
      // this.bankcodevalue=this.bankcodevalue;
      // this.getAccountInfoGrid();
    }

    const currentYear = new Date().getFullYear();
    for (let year = 2017; year <= currentYear; year++) {
      this.years.push(year);
    }

  }

  getAccountInfoGrid() 
  {
    this.backendService.getData(`${CONFIG.getAccountInfoGridApiUrlBase}/${this.bankcodevalue}`)
      .subscribe(response => {console.log(response);
        this.formateData(response['accountifo']);
        this.items = response['accountifo'];
        this.dasubmission=response['dasubmissions'];
        //console.log(this.dasubmission);
        //this.afterEditData=this.items;
       // console.log(this.items);
      })
  }
  formateData(data)
  {
    data.map(d => {
      d.lasttransdate = this._datepipe.transform(d.lasttransdate.toString(), "MM/dd/yyyy");

    });
  }
  valueOfAccountNo(value,item)
  {
    item.accountno=value;
    //console.log(value);
  }
  valueOfCurrencyCode(value,item)
  {
    item.currencycode=value;
    //console.log(value);
  }
  valueOfAccountBalance(value,item)
  {
    item.acctBalance=value;
   // console.log(value);
  }
  valueOfAdditionalfund(value,item)
  {
    if(value=="")
    {
      item.additionalfunds=0;
    }
    item.additionalfunds=value;
    console.log(value);
  }
  valueOfBranchCode(value,item)
  {
    item.branchCode=value;
    //console.log(value);
  }
  valueOfAccountType(value,item)
  {
    item.accountType=value;
    //console.log(value,item);
  }
  valueOfDate(value,item)
  {
    this.editDate=value;
    this.editDate=this._datepipe.transform(value.toString(),"MM/dd/yyyy");
   // console.log(this.editDate);
    item.lasttransdate=this.editDate;
   // console.log("test Date");
    //console.log(value,item);
  }
  editAccountInfo(item)
  {

    //this.getAccountInfoGrid();
    //item.lasttransdate=this.items.lasttransdate;
    // if(this.editDate==undefined)
    // {
    //   console.log("undefined",this.items.lasttransdate);
    //   item.lasttransdate="02/04/2020";
    // }
    // else
    // {
    //   console.log("value");
    //   item.lasttransdate=this.editDate;
    // }
    
    //this.afterdate=item.lasttransdate.value;
   this.tableForm.addControl['lasttransdate']=item.lasttransdate.value;
    item.approved=true;
    this.editvalue=false;
    this.hidebutton=false;
    //console.log(item,this.items);
  }
  setvalue(event)
  {
    this.accValue = event.target.value;
    // console.log("avrg trans");
    // const formatter = new Intl.NumberFormat('en-US', {
    //   // style: 'currency',
    //   // currency: 'USD',
    //    minimumFractionDigits: 2
      
    // });
    // this.accValue = event.target.value;
    
    // this.displayvalue.floatValue = formatter.format(this.accValue);
    // console.log(this.displayvalue.floatValue);
  }
  setvalueAdd(event)
  {
    this.addValue=event.target.value;
  }
  SaveEditRecordData(finalData)
  {
    //finalData.lasttransdate=this.editDate;
    finalData.approved=false;
    
    this.editvalue=true;
    this.hidebutton=true;
    //console.log(finalData);
    this.backendService.putData(finalData,`${CONFIG.dataentryUpdateApiUrlBase}`)
                  .subscribe(response=>{
                    //console.log(response);
                  if(response['result'])
                  {
                    this.notificationService.showNotification({ type: 'success', message:response['msg']});
                  }
                  else
                  {
                    this.notificationService.showNotification({ type: 'error', message:response['msg']});
                  }
                  
                  });
  }

  editDASubmission(item)
  {
    item.submitted=true;
    //item.status=false;
  //  console.log(item);
  }
  valueOfTotalAmount(value,item)
  {
    item.totalamount=value;
    console.log(value,item);
  }
  valueOfPaymentMethod(value,item)
  {
    item.paymentmethod=value;
   // console.log(value,item);
  }
  valueOfCheckNo(value,item)
  {
    item.referenceno=value;
    //console.log(value,item);
  }
  UpdateDASubmission(item)
  {
    item.submitted=false;
   // console.log(item);
    if(this.authService.LoginType=="Admin")
    {
    this.backendService.putData(item,`${CONFIG.updateDASubmissionsApiUrlBase}`)
                        .subscribe(response=>{
                          //console.log(response);
                          if(response['result'])
                        {
                          this.notificationService.showNotification({ type: 'success', message:response['msg']});
                        }
                          else
                        {
                          this.notificationService.showNotification({ type: 'error', message:response['msg']});
                        }
                      });
                    }
                    else
                    {
                      item.bankcode=this.authService.TaskNumber;
                      this.backendService.putData(item,`${CONFIG.updateDASubmissionsApiUrlBase}`)
                                        .subscribe(response=>{
                                          //console.log(response);
                                          if(response['result'])
                                        {
                                          this.notificationService.showNotification({ type: 'success', message:response['msg']});
                                        }
                                          else
                                        {
                                          this.notificationService.showNotification({ type: 'error', message:response['msg']});
                                        }
                                      });
                    }
                
  }
  editRoute(item, type) 
  {
    this.editvalue=false;
  //  console.log(this.item, type);
    const myThis = this;
    this.openDialog(item, type);
  }

  openDialog(accountEdit: any, type: any): void {

    this.bankcodevalue = this.dataEntry.controls['BankCode'].value;
    // this.branchcodevalue = this.dataEntry.controls['BranchCode'].value;
    //console.log(updatedAccount);
    // submittedInfo.branchcode = this.branchcodevalue;
   // updatedAccount.bankcode = this.bankcodevalue;

    //localStorage.setItem('key', key);
    //console.log(updatedAccount);
    if(type=='DaSubmission'){
      this.ComponentName = DataEntryDASubmissionComponent;
    }
    else
    this.ComponentName = DataEntryAccountEditComponent;

    let dialogRef = this.dialog.open(this.ComponentName, {
      width: '80%',
      height: '60%',
      data: { accountEdit }
    });
    // this.router.navigate(['/dashboard']);
    dialogRef.afterClosed().subscribe(result => {
      this.getAccountInfoGrid();
      //this.serviceInit();
    });
  }

  makeActive(item) 
  {
    
     this.active === item ? '' : item;
  }

  getbankIdDropdown() {
    this.bankcodevalue = this.dataEntry.controls['BankCode'].value;
    this.backendService.getData(`${CONFIG.getbankIdDropdownApiUrlBase}`)
      .subscribe(response => {
        this.bankId = response['bankid'];
        //this.branchcodes = response['branchcodelist'];
        this.bankbranchids = response['bankbranchids'];
        this.submissionrecords = response['submissionrecords'];

                        if(this.authService.LoginType!="Admin")   
                        {  
                        let myArray = [];
                        this.bankcodevalue = this.authService.TaskNumber;
                        this.branchfiltercodes = this.bankbranchids.filter(x => x.bankCode == this.bankcodevalue);
                        for (var i = 0; i < this.branchfiltercodes.length; i++) {
                          this.branchessss = this.branchfiltercodes[i]['branchCode'];
                          myArray.push(this.branchessss);
                          //console.log(myArray);
                        
                        
                      }
                      this.branchcodes = myArray;
                      }


       // console.log(this.submissionrecords);
        this.totalsubmissionrecordsEntries = this.submissionrecords.length;

        this.setGrid(1, this.totalsubmissionrecordsEntries, "search");
        this.entryRangeSubscription = this.paginationService.entryRange
          .subscribe(range => {
            this.entryRange = range;
            //this.submissionrecords=this.submissionrecords.filter(x=>x.bankcode==this.bankcodevalue);
           // console.log(this.submissionrecords,this.bankcodevalue);
            //this.submissionrecords = this.submissionrecords.slice(this.entryRange[0], this.entryRange[1]);
            //this.exportItems = this.datefilteredaudit;
                        
            this.totalsubmissionrecordsEntries = this.submissionrecords.length;
          });

      });
    this.backendService.getData(`${CONFIG.getdataentryDropdownsApiUrlBase}`)
      .subscribe(response => {
        this.accounttype = response['accounttype'];
        this.currency = response['currency'];
        this.currencies = response['currencies'];
        if(this.authService.LoginType!="Admin")
        {
          //console.log(this.currencies);
          for(let i=0;i<this.currencies.length;i++)
          this.currencies[i].totalamount=0;
          //console.log(this.currencies);
          this.submissionrecordsfilter= this.currencies;
          //this.submissionrecordsfilter.totalamount=0.00;
          this.submission = true;
          //if(this.submissionrecords.>0)
          //this.submissionrecordsfilter = this.submissionrecords.filter(x => x.bankcode == this.authService.TaskNumber);
        }
        //console.log(this.accounttype, this.currency, this.currencies);
      });
      this.bankcodevalue=this.bankcodevalue;
      if(this.bankcodevalue!=null)
        this.getAccountInfoGrid();
  }
  setGrid(start: number, length?: number, value?: string) {
    //console.log(length);
    const sentLen = length;
    //this.pagenlenth = false;

    this.paginationService.setGrid(start, sentLen);
  }
  filterBranchCode() {

    let myArray = [];
    this.bankcodevalue = this.dataEntry.controls['BankCode'].value;
    this.branchfiltercodes = this.bankbranchids.filter(x => x.bankCode == this.bankcodevalue);
    for (var i = 0; i < this.branchfiltercodes.length; i++) {
      this.branchessss = this.branchfiltercodes[i]['branchCode'];
      myArray.push(this.branchessss);
     // console.log(myArray);

    }
    this.branchcodes = myArray;
    this.submission = true;
    //this.submissionrecords = this.submissionrecords;
    this.submissionrecordsfilter = this.submissionrecords.filter(x => x.bankcode == this.bankcodevalue);
    
   // console.log(this.submissionrecordsfilter,this.bankcodevalue);
    this.getAccountInfoGrid();
  }

  onSubmit(submittedInfo) 
  {
    this.spinner=false;
    if(this.authService.LoginType=="Admin")
    {
    this.bankcodevalue = this.dataEntry.controls['BankCode'].value;
    // this.branchcodevalue = this.dataEntry.controls['BranchCode'].value;
    //console.log(submittedInfo);
    // submittedInfo.branchcode = this.branchcodevalue;
    if(this.bankcodevalue=="")
    {
        this.alert.openConfirmationDialog("Please Select Bank ID.");
    }
    else if(submittedInfo.FirstName=="" || submittedInfo.LastName=="" || submittedInfo.Position==""||submittedInfo.Email==""||submittedInfo.Comments==""||submittedInfo.PhoneNumber=="")
    {
      this.alert.openConfirmationDialog("You must fill the fields.");
    }
    else
    {
    submittedInfo.bankcode = this.bankcodevalue;
    //submittedInfo.submittedyear=this.submittedYear;
    submittedInfo.paymentdate=this._datepipe.transform(this.paymentdate.value,"MM/dd/yyyy");
    //console.log(submittedInfo.branchcode);
    this.backendService.postData(submittedInfo, `${CONFIG.dataentrySubmitApiUrlBase}`)
      .subscribe(response => {
        if (response['result']) 
        {
          this.spinner=true;
          this.setForm();
          this.alert.openConfirmationDialog(response['msg']);
          // this.notificationService.showNotification({ type: 'success', message: response['msg'] });
          this.router.navigate(['/dashboard']);
        }
        else 
        {
          this.alert.openConfirmationDialogLong(response['msg']);
          // this.notificationService.showNotification({ type: 'error', message: response['msg'] });
        }

      });
    }
  }
  else
  {
    this.bankcodevalue = this.authService.TaskNumber;
    // this.branchcodevalue = this.dataEntry.controls['BranchCode'].value;
    //console.log(submittedInfo);
    // submittedInfo.branchcode = this.branchcodevalue;
    
   if(submittedInfo.FirstName=="" || submittedInfo.LastName=="" || submittedInfo.Position==""||submittedInfo.Email==""||submittedInfo.Comments==""||submittedInfo.PhoneNumber=="")
    {
      this.alert.openConfirmationDialog("You must fill the fields.");
    }
    else
    {
    submittedInfo.bankcode = this.authService.TaskNumber;
   // submittedInfo.submittedyear=this.submittedYear;
    submittedInfo.paymentdate=this._datepipe.transform(this.paymentdate.value,"MM/dd/yyyy");
    //console.log(submittedInfo.branchcode);
    this.backendService.postData(submittedInfo, `${CONFIG.dataentrySubmitApiUrlBase}`)
      .subscribe(response => {
        if (response['result']) {
          this.setForm();
          this.spinner=false;
          this.alert.openConfirmationDialog(response['msg']);
          // this.notificationService.showNotification({ type: 'success', message: response['msg'] });
          this.router.navigate(['/dashboard']);
        }
        else 
        {
          this.alert.openConfirmationDialogLong(response['msg']);
          // this.notificationService.showNotification({ type: 'error', message: response['msg'] });
        }

      });
    }
  }

  }
  addItem(value) {

  }
  valueOfDateadd(value)
  {
    
    this.editDate1=this._datepipe.transform(value.toString(),"MM/dd/yyyy");
    //console.log(this.editDate1);
   
  }


  addAccount(AccountInfo) {
    if(this.authService.LoginType=="Admin")
    {
      this.bankcodevalue = this.dataEntry.controls['BankCode'].value;
   // console.log(this.bankcodevalue);
    if(this.bankcodevalue=="")
    {
     // console.log("test111");
        this.alert.openConfirmationDialog("Please Select Bank ID.");
    }
    else
    {
   // console.log(AccountInfo);
    AccountInfo.bankcode = this.bankcodevalue;
    AccountInfo.lasttransdate=this.editDate1;
   // console.log(AccountInfo.bankcode);
    this.backendService.postData(AccountInfo, `${CONFIG.dataentryAddApiUrlBase}`)
      .subscribe(response => {
        if (response) {
          this.setForm1();
          this.notificationService.showNotification({ type: 'success', message: response['msg'] });
          this.getAccountInfoGrid();
          //console.log(CONFIG.dataentryAddApiUrlBase);
        }
        else {
          this.notificationService.showNotification({ type: 'error', message: response['msg'] });
        }

      });
    }
  }
  else
  {
    this.bankcodevalue = this.authService.TaskNumber;
    //console.log(this.bankcodevalue);
    if(this.bankcodevalue=="")
    {
     // console.log("test111");
        this.alert.openConfirmationDialog("Please Select Bank ID.");
    }
    else
    {
   // console.log(AccountInfo);4
    AccountInfo.bankcode = this.bankcodevalue;
    AccountInfo.lasttransdate=this.editDate1;
    //console.log(AccountInfo.bankcode);
    this.backendService.postData(AccountInfo, `${CONFIG.dataentryAddApiUrlBase}`)
    
      .subscribe(response => {
        if (response) {
          this.setForm();
          this.notificationService.showNotification({ type: 'success', message: response['msg'] });
          this.getAccountInfoGrid();
          //console.log(CONFIG.dataentryAddApiUrlBase);
        }
        else {
          this.notificationService.showNotification({ type: 'error', message: response['msg'] });
        }

      });
    }
  }
  }

  deleteConfirm(transno) {
    //console.log(transno);
    this.backendService.deleteData(`${CONFIG.dataentryDeleteApiUrlBase}/${transno}`)
    .subscribe(response => {
      if (response) {
        this.setForm();
        this.notificationService.showNotification({ type: 'success', message: response['msg'] });
        this.getAccountInfoGrid();
      }
      else {
        this.notificationService.showNotification({ type: 'error', message: response['msg'] });
      }

    });
}
setForm1()
{
  this.tableForm = this._formBuilder.group({
    'AccountType': [''],
    'BranchCode': [''],
    'Currency': [''],
    'additionalfunds': [''],
    'accountbalance': [''],
    'accountno': [''],
    'lasttransdate': [''],
    'afterdate':[''],
    //'additionalfunds': ['']    
  });
}

  setForm() {
    this.dataEntryForm = this._formBuilder.group({
      // 'BankId':[''] ,      
      'submittedyear': [''],
      'FirstName': [''],
      'MiddleName': [''],
      'LastName': [''],
      'Position': [''],
      'Email': [''],
      'PhoneNumber': [''],
      'Comments': ['']
    });

    this.dataEntry = this._formBuilder.group({
      'BankCode': [],
      //'BranchCode': [''],
      'new_id': [''],
      'edited_id': ['']
    });
    this.tableForm = this._formBuilder.group({
      'AccountType': [''],
      'BranchCode': [''],
      'Currency': [''],
      'additionalfunds': [''],
      'accountbalance': [''],
      'accountno': [''],
      'lasttransdate': [''],
      'afterdate':[''],
      //'additionalfunds': ['']    
    });
  }
}
